import {useEffect, useState} from "react";
import {notification} from "antd";
import {HistoryTimeline} from "~/components";
import {userApi} from "~/api";
import {apiError, handleRequest} from "~/utils";

/**
 * Lịch sử thao tác trên tài khoản nhân viên.
 * Hiển thị ai thao tác - thời gian - hành động gì; với cập nhật có bảng so sánh trước/sau.
 */
function PersonnelHistory({item}) {

	const [histories, setHistories] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const loadData = async () => {
			if (!item?.id) return;
			setLoading(true);
			let [error, response] = await handleRequest(userApi.history(item.id));
			setLoading(false);
			let message = apiError('Tải lịch sử thao tác thất bại', error, response);
			if (!message) {
				setHistories(response.data || []);
			} else {
				notification.error({message: 'Lỗi', description: message});
			}
		};

		setHistories([]);
		loadData();
	}, [item?.id]);

	return (
		<div className="form">
			<HistoryTimeline
				histories={histories}
				loading={loading}
				emptyText="Chưa có lịch sử thao tác nào cho nhân viên này"
			/>
		</div>
	);
}

export default PersonnelHistory;
